export default __webpack_public_path__ + "static/SpotLight-4b6bbd3fcbf366b0c93aacc963520cb8d8911e1a0a9168f996dbe37919848715.png";